/**
 * Sales Dashboard — placeholder page.
 *
 * Wired into the admin SPA at /sales/dashboard with a SUPER_ADMIN gate so
 * the route is reachable today. The actual dashboard content (revenue,
 * pipeline, conversion KPIs) is intentionally deferred — this page exists
 * to anchor the Sales sidebar group and reserve the URL.
 */
import React from 'react';
import { TrendingUp } from 'lucide-react';
import { SecurityBoundary } from '@vehix/portal/lib/security';
import { SystemRole } from '@vehix/portal/types';

const SalesDashboardPage: React.FC = () => {
  return (
    <SecurityBoundary
      requiredSystemRole={SystemRole.SUPER_ADMIN}
      auditPageAccess='sales-dashboard'
      tenantIsolation={false}
    >
      <div className='flex h-full w-full items-center justify-center p-8'>
        <div className='max-w-md text-center space-y-4'>
          <div className='mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-muted'>
            <TrendingUp className='h-8 w-8 text-muted-foreground' />
          </div>
          <h1 className='text-2xl font-bold tracking-tight'>Sales Dashboard</h1>
          <p className='text-sm text-muted-foreground'>
            Coming soon. This space will house the sales dashboard with revenue,
            pipeline, and conversion metrics.
          </p>
        </div>
      </div>
    </SecurityBoundary>
  );
};

export default SalesDashboardPage;
